// src/components/Authentication/AppleAuthButton.jsx
import React, { useContext } from "react";
import { useAppleSignIn } from "../../hooks/useAppleSignIn";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AppleAuthButton.css";
import appleIcon from "../../assets/icons/brands/apple.svg";
import { trackAnalyticsEvent } from "../../analytics/analytics";

const AppleAuthButton = ({ className = "", onSuccess, onError, affiliateCode = null, newsletter = false }) => {
  const { signIn: appleSignIn } = useAppleSignIn();
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "en";

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleAppleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    setError(null);

    try {
      const data = await appleSignIn({
        affiliate: affiliateCode,
        user_service: true,
        newsletter: newsletter,
      });

      setToken(data.access_token);
      localStorage.setItem("token", data.access_token);

      if (data?.is_new_user || data?.is_new) {
        trackAnalyticsEvent.signUp("Apple");
      } else {
        trackAnalyticsEvent.login("Apple");
      }

      if (onSuccess) onSuccess(data);
      navigate(`/${currentLang}/shop`);
    } catch (err) {
      console.error("Apple login error:", err);
      setError(err.message || "Apple login failed");
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button type="button" className={`apple-auth-btn`} onClick={handleAppleLogin} disabled={loading} aria-label="">
      <img src={appleIcon} width="22" height="22" alt="Apple Login" aria-label="" />
    </button>
  );
};

export default AppleAuthButton;
